function resizeVideo() {
  var elements = document.querySelectorAll("video");
  elements.forEach((element) => {
    var videoDesktop = element.dataset.videoDesktop;
    var videoPhone = element.dataset.videoPhone;

    if (videoDesktop && videoPhone) {
      if (window.innerWidth >= 768) {
        if (element.src !== videoDesktop) {
          element.setAttribute("src", videoDesktop);
        }
      } else {
        if (element.src !== videoPhone) {
          element.setAttribute("src", videoPhone);
        }
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function (event) {
  window.addEventListener("resize", resizeVideo);
  resizeVideo();
});
